import type { Translate } from '@application/types';
import type { WhatsappModalFormValues } from '@presentation/components';

export const formatWhatsAppUrl = (params: {
  values: WhatsappModalFormValues;
  number: string;
  translate: Translate;
  resource?: 'pro' | 'breeder';
}) => {
  const { translate, number, values, resource = 'pro' } = params;
  const incipit = `${translate(`common.modals.whatsApp.incipit.${resource}`)}\n`;
  const formattedName = `- ${translate('glossary.name')}: ${values.firstName} ${values.lastName}\n`;

  const formattedEmail = `- ${translate('common.inputs.email.label')}: ${values.email}\n`;
  const formattedMessage = `- ${translate('common.inputs.message.label')}: ${values.message}\n`;

  const encodedText = encodeURI(
    [incipit, formattedName, formattedEmail, formattedMessage].filter((x) => !!x).join(''),
  );
  const targetUrl = `https://wa.me/${number}?text=${encodedText}`;
  return targetUrl;
};
